import { render } from "./Bestellen.vue?vue&type=template&id=3532ddbe&scoped=true"
import script from "./Bestellen.vue?vue&type=script&lang=js"
export * from "./Bestellen.vue?vue&type=script&lang=js"

import "./Bestellen.vue?vue&type=style&index=0&id=3532ddbe&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3532ddbe"]])

export default __exports__